






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AppCard extends Vue {
  @Prop({ default: false }) readonly clickable: boolean
  @Prop({ default: false }) isActive

  get cardClass () {
    return `app-card-container ${this.clickable ? 'clickable' : ''}`
  }
}
